import { useSearchParams } from 'react-router-dom';
import { useEffect } from 'react';

interface UseModalSearchParamOptions {
  paramName: string;
  onOpen?: () => void;
  onClose?: () => void;
}

export function useModalSearchParam({ paramName, onOpen, onClose }: UseModalSearchParamOptions) {
  const [searchParams, setSearchParams] = useSearchParams();

  const isOpen = searchParams.has(paramName);

  const open = () => {
    setSearchParams(prev => {
      prev.set(paramName, 'true');
      return prev;
    });
    onOpen?.();
  };

  const close = () => {
    setSearchParams(prev => {
      prev.delete(paramName);
      return prev;
    });
    onClose?.();
  };

  // Handle initial state from URL
  useEffect(() => {
    if (isOpen) {
      onOpen?.();
    }
  }, []);

  return {
    isOpen,
    open,
    close
  };
}
